interface IPickerPosition {
  x: number;
  y: number;
}

/**
 * Helper class for managing color picker position and tracking click events
 */
export class ColorPickerPositionHelper {
  private static lastClickEvent: MouseEvent | null = null;

  // Last painted position of the open picker, kept here so it survives a
  // re-render that resets the component's state position to {0,0}.
  private static openPickerPosition: IPickerPosition | null = null;

  public static saveLastClickEvent(event: MouseEvent): void {
    this.lastClickEvent = event;
  }

  public static getLastClickEvent(): MouseEvent | null {
    return this.lastClickEvent;
  }

  public static saveOpenPickerPosition(position: IPickerPosition): void {
    this.openPickerPosition = position;
  }

  public static getOpenPickerPosition(): IPickerPosition | null {
    return this.openPickerPosition;
  }

  public static clearOpenPickerPosition(): void {
    this.openPickerPosition = null;
  }

  public static calculateOptimalPosition(
    event: MouseEvent,
    pickerWidth: number = 254,
    pickerHeight: number = 400
  ): { x: number; y: number } {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let x = event.clientX + 10;
    let y = event.clientY - 50;

    if (x + pickerWidth > viewportWidth) {
      x = event.clientX - pickerWidth - 10;
    }

    y = Math.max(10, Math.min(y, viewportHeight - pickerHeight - 10));

    return { x, y };
  }
}
